<template>
    <div
        class="widget d-flex flex-column justify-content-start align-items-center px-1 px-md-3 py-1 py-md-2 m-1"
    >
        <h6 class="mb-0 text-uppercase">Goal progress</h6>
        <small class="text-muted mb-0"
            ><em>{{ timeSinceFirstAssessment }}</em></small
        >
        <hr style="width:100%;margin:0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;" />
        <div
            :id="goal ? 'goal' + goal.id : id"
            class="prog-circle d-flex flex-column justify-content-center position-relative align-items-center"
            style=""
        >
            <h5 class="position-absolute font-weight-bold">{{ trackers.length }}</h5>
        </div>
        <p class="text-uppercase font-weight-bold text-center">Assessments complete</p>
    </div>
</template>

<script>
export default {
    name: "GoalsProgressPreferenceAssessment",
    props: ["goal", "trackers"],
    data() {
        return {
            p: null,
        };
    },
    mounted() {
        this.drawProgress();
    },
    watch: {
        goal() {
            this.updateProgress();
        },
    },
    computed: {
        timeSinceFirstAssessment() {
            if (!this.trackers.length) {
                return "No assessments yet";
            } else {
                return `${this.moment(this.trackers[0].created_at).fromNow(
                    true
                )} since first assessment`;
            }
        },
    },
    methods: {
        drawProgress() {
            this.p = new this.ProgressBar.Circle(
                `#${this.goal ? "goal" + this.goal.id : this.id}`,
                {
                    strokeWidth: 7,
                    easing: "easeInOut",
                    duration: 1400,
                    color: this.goal ? this.goal.domain.color : this.color,
                    trailColor: "#c6c6c8",
                    trailWidth: 7,
                    svgStyle: null,
                }
            );
            this.p.animate(1);
        },
        updateProgress() {
            let path = document.querySelector(`.prog-circle > svg > path:last-child`);
            if (path) {
                path.setAttribute("stroke", this.goal ? this.goal.domain.color : this.color);
            }
            this.p.animate(1);
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
    > .prog-circle {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
    }
    > .prog-circle > h5 {
        font-family: "Roboto Condensed", sans-serif;
        top: 0.6rem;
        left: 0.5rem;
        > small {
            font-weight: lighter;
            font-size: 60%;
        }
    }
    > p {
        padding-top: 0.5rem;
        font-size: 0.5rem;
        line-height: 1;
        word-spacing: 200px;
    }
}

@media screen and (min-width: 768px) {
    .widget {
        > .prog-circle {
            min-width: 70px;
            min-height: 70px;
            max-width: 70px;
            max-height: 70px;
        }
        > .prog-circle > h5 {
            font-size: 2rem;
            top: 1rem;
            width: 100%;
            left: 0;
            text-align: center;
        }
        > p {
            font-size: 0.7rem;
        }
    }
}

@media screen and (min-width: 992px) {
    .widget {
        > .prog-circle {
            min-width: 100px;
            min-height: 100px;
            max-width: 100px;
            max-height: 100px;
        }
        > .prog-circle > h5 {
            font-size: 3rem;
            top: 1.4rem;
            width: 100%;
            left: 0;
            text-align: center;
        }
        > p {
            font-size: 1rem;
        }
    }
}
</style>
